import sqftEventManager from "../../../store/sqftEventManager";
import DrawImage from "../textBox/draw/drawImage";
import {pnpolyArray} from "../../../../../lib/pnpoly";
import config from "../../../store/sqftConfig";
import sqftConfig from "../../../store/sqftConfig";
import RenderFigures from "../../../helpers/renderFigures";

class StaticImage {
  svgImageId;
  ctx;
  x;
  y;
  width;
  height;
  isCentered = true;
  isScale = true;
  beforeRenderCallback = function (){};

  /**
   * returns a list needed for integration
   * @param svgImageId {string}
   * @param x {int}
   * @param y {int}
   * @param width {int}
   * @param height {int}
   * @param isCentered {boolean}
   * @param isScale {boolean}
   * @param beforeRenderCallback {function}
   */
  constructor(svgImageId, x, y, width, height, isCentered, isScale, beforeRenderCallback) {
    this.svgImageId = svgImageId;
    this.ctx = sqftEventManager.getCtx();
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.isCentered = isCentered;
    this.isScale = isScale;
    this.beforeRenderCallback = beforeRenderCallback ? beforeRenderCallback : function (){};
  }

  isHovered = (mousePos) => {
    return pnpolyArray(this.getHoverArray(), mousePos);
  }

  getHoverArray = () => {
    const width = this.width * config.defaultScale;
    const height = this.height * config.defaultScale;

    if (this.isCentered) {
      return [
        [this.x - width / 2, this.y - height / 2],
        [this.x + width / 2, this.y - height / 2],
        [this.x + width / 2, this.y + height / 2],
        [this.x - width / 2, this.y + height / 2],
      ];
    } else {
      return [
        [this.x, this.y],
        [this.x + width, this.y],
        [this.x + width, this.y + height],
        [this.x, this.y + height],
      ];
    }
  }

  render = () => {
    this.beforeRenderCallback();
    DrawImage.renderImage(this.svgImageId,
      this.ctx,
      this.x,
      this.y,
      this.width,
      this.height,
      this.isCentered,
      this.isScale
    );
    if (sqftConfig.isDevMode()) {
      RenderFigures.renderPolygonArray(this.getHoverArray());
    }
  }
}

export default StaticImage
